module.exports = __webpack_public_path__ + "img/2025-th.b4ab1503.jpg";